import { useState, useEffect } from 'react';

export const useIsMobile = (breakpoint: number = 768): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkIsMobile = () => {
      // Check both screen width and user agent for comprehensive mobile detection
      const screenWidth = window.innerWidth;
      const userAgent = navigator.userAgent.toLowerCase();
      
      // Common mobile user agent patterns
      const mobilePatterns = [
        /android/i,
        /webos/i,
        /iphone/i,
        /ipad/i,
        /ipod/i,
        /blackberry/i,
        /windows phone/i,
        /mobile/i
      ];
      
      const isMobileUserAgent = mobilePatterns.some(pattern => pattern.test(userAgent));
      const isMobileScreen = screenWidth < breakpoint;
      
      // Consider it mobile if either condition is true
      setIsMobile(isMobileUserAgent || isMobileScreen);
    };

    // Check on mount
    checkIsMobile();

    // Add resize listener for responsive behavior
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, [breakpoint]);

  return isMobile;
};